module.exports = __webpack_public_path__ + "img/lk.2976338.svg";